import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
var tabStyles = css(["flex:1 0 auto;align-self:stretch;display:flex;align-items:center;border:none;background:none;padding:0 4px;font-size:1rem;box-sizing:border-box;cursor:pointer;text-decoration:none;color:", ";position:relative;justify-content:center;margin-right:1rem;font-family:inherit;&:before{content:'';position:absolute;top:8px;bottom:8px;left:0;right:0;border:2px solid transparent;border-radius:", " ", " 0 0;pointer-events:none;}&:after{content:'';display:block;height:3px;border-radius:", " ", " 0 0;position:absolute;right:0;bottom:0;left:0;background:transparent;transition:all 200ms ease;background:", ";}&:last-child{margin-right:0;}&:focus{outline:none;&:before{border-color:currentColor;}&:after{background:", ";}}&:hover{&:after{background:", ";}}&::-moz-focus-inner{border:0;}&:active{&:after{height:0;}}span:focus{outline:none;}"], function (props) {
  return props.themeName === TscThemeName.dawn ? tscStyles.color.text.dark : tscStyles.color.text.light;
}, tscStyles.border.radius.xxs, tscStyles.border.radius.xxs, tscStyles.border.radius.xxs, tscStyles.border.radius.xxs, function (props) {
  return props.isSelected ? props.selectedColor : 'initial';
}, tscStyles.color.action.primary, tscStyles.color.text.lightMedium);
var Container = styled.div.withConfig({
  displayName: "Tabs__Container"
})(["display:flex;align-self:stretch;"]);
var TabAnchor = styled.a.withConfig({
  displayName: "Tabs__TabAnchor"
})(["", ""], tabStyles);
var TabButton = styled.button.withConfig({
  displayName: "Tabs__TabButton"
})(["", ""], tabStyles);
var TabButtonSpan = styled.span.withConfig({
  displayName: "Tabs__TabButtonSpan"
})(["width:100%;"]);

var Tabs = function Tabs(_ref) {
  var className = _ref.className,
      _ref$isAnchor = _ref.isAnchor,
      isAnchor = _ref$isAnchor === void 0 ? false : _ref$isAnchor,
      _ref$selectedColor = _ref.selectedColor,
      selectedColor = _ref$selectedColor === void 0 ? tscStyles.color.action.primary : _ref$selectedColor,
      tabs = _ref.tabs,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName;

  var getTab = function getTab(tab, index) {
    var onClick = function onClick(e) {
      if (tab.onClick) {
        e.preventDefault();
        tab.onClick(e);
      }
    };

    var key = tab.text + index;
    return isAnchor ? _jsx(TabAnchor, {
      className: getClassName(className, 'tab-anchor'),
      isSelected: tab.isSelected,
      role: "tab",
      "aria-selected": tab.isSelected,
      selectedColor: selectedColor,
      onClick: onClick,
      href: tab.href,
      themeName: themeName,
      children: _jsx("span", {
        children: tab.text
      })
    }, key) : _jsx(TabButton, {
      className: getClassName(className, 'tab-button'),
      isSelected: tab.isSelected,
      role: "tab",
      "aria-selected": tab.isSelected,
      selectedColor: selectedColor,
      onClick: onClick,
      themeName: themeName,
      children: _jsx(TabButtonSpan, {
        className: getClassName(className, 'tab-button-span'),
        tabIndex: -1,
        children: tab.text
      })
    }, key);
  };

  return _jsx(Container, {
    className: getClassName(className, null, 'tabs-container'),
    role: "tablist",
    children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, index) {
      return getTab(tab, index);
    })
  });
};

var TabsTest = {
  Container: Container,
  TabAnchor: TabAnchor,
  TabButton: TabButton,
  TabButtonSpan: TabButtonSpan
};
export { Tabs, TabsTest };
export default Tabs;